export default {
	title: 'IoT Card Management',
	actions: {
		add: 'Add',
                import: 'Import',
                exportTemplate: 'Template Export',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		expiringSoon: 'Expiry Warning'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete {count} selected record(s)?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the record to delete',
		operateSuccess: 'Operation successful',
                requiredFieldCannotBeEmpty: 'Required field cannot be empty',
                importSuccess: 'Import successful',
                importFailed: 'Import failed: ',
                fileTooLarge: 'File size cannot exceed 100MB'
	},
	form: {
		projNo: 'Project Number',
		number: 'IoT Card Number',
		iccid: 'ICCID',
		placeholder: {
			projNo: 'Please enter project number',
			number: 'Please enter IoT card number',
			iccid: 'Please enter ICCID',
			buyDateStart: 'Purchase start date',
			buyDateEnd: 'Purchase end date',
			expireDateStart: 'Expiry start date',
			expireDateEnd: 'Expiry end date'
		}
	},
	table: {
		number: 'IoT Card Number',
		iccid: 'IC Card ID',
		projNo: 'Project Number',
		bindType: 'Gateway/Sensor',
		terminalId: 'Terminal ID',
		sensorId: 'Related Sensor',
		buyDate: 'Purchase Date',
		expireDate: 'Expiration Date',
		status: 'Card Status',
		active: 'Activation Status',
		trafficMonthly: 'Monthly Traffic',
		trafficUsed: 'Used Traffic (M)',
		serviceCycle: 'Service Cycle',
		mobileCarrier: 'Carrier'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		number: 'IoT Card Number',
		iccid: 'IC Card ID',
		projNo: 'Project',
		bindType: 'Bind Type',
		terminalId: 'Terminal/Gateway ID',
		sensorId: 'Related Sensor ID',
		buyDate: 'Purchase Date',
		expireDate: 'Expiration Date',
		allotDate: 'Allocation Date',
		trafficMonthly: 'Monthly Traffic',
		trafficUsed: 'Used Traffic',
		mobileCarrier: 'Carrier',
		serviceCycle: 'Service Cycle',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			number: 'Please enter IoT card number',
			iccid: 'Please enter IC card ID',
			projNo: 'Please enter project number',
			bindType: 'Please select bind type',
			terminalId: 'Please enter terminal/gateway ID',
			sensorId: 'Please enter related sensor ID',
			buyDate: 'Please select purchase date',
			expireDate: 'Please select expiration date',
			allotDate: 'Please select allocation date',
			trafficMonthly: 'Please enter monthly traffic',
			trafficUsed: 'Please enter used traffic',
			mobileCarrier: 'Please select carrier',
			serviceCycle: 'Please enter service cycle'
		},
		options: {
			bindType: {
				gateway: 'Gateway',
				sensor: 'Sensor'
			},
			mobileCarrier: {
				telecom: 'Telecom',
				mobile: 'Mobile',
				unicom: 'Unicom'
			}
		}
	}
}
